import { Text } from "@chakra-ui/react";
import React from "react";
import { TableHeaderCell, TableHeaderRow } from "./Table";

export function LedgerTableHeaders({
  editMode,
}: {
  editMode: boolean;
}): React.ReactElement {
  return (
    <TableHeaderRow>
      <TableHeaderCell flexGrow={1.5}>
        <Text>Type</Text>
      </TableHeaderCell>
      <TableHeaderCell>
        <Text>Quantity</Text>
      </TableHeaderCell>
      <TableHeaderCell>
        <Text>Asset</Text>
      </TableHeaderCell>
      <TableHeaderCell justifyContent="flex-end">
        <Text>Market Value</Text>
      </TableHeaderCell>
      {editMode && (
        <TableHeaderCell maxW="2rem">{/* Delete Action */}</TableHeaderCell>
      )}
    </TableHeaderRow>
  );
}
